module.exports = __webpack_public_path__ + "img/warning.279d2227.svg";